<template>
<row-card :imageUrl="imageUrl" :leftTitle="name"
  :leftSubtitle="locations"
  :rightTitle="role"
  :rightSubtitle="company"
  v-on:click="click"
  >
  </row-card>
</template>

<script>
import RowCard from '@/components/general/row-card'
import DropdownModal from '@/components/dropdown-modal'
import ReferralRemoveModal from '@/components/referrals/referral-remove-modal'

export default {
  components: {RowCard, DropdownModal, ReferralRemoveModal},
  props: {
    item: {
      type: Object,
      required: true
    },
    itemindex: {
      type: Number,
      required: false,
      default: -1
    }
  },
  data () {
    return {
      modalActive: false
    }
  },
  computed: {
    email () {
      if (this.item.id || this.item.id) {
        return ''
      } else {
        return this.item
      }
    },
    user () {
      if (this.item.id || this.item.id) { return this.item }
      return null
    },
    imageUrl () {
      const user = this.user
      if (user) {
        return user.profilePictureUrl || `/api/identicons/${user.id}`
      } else {
        return `/api/identicons/${this.email}`
      }
    },
    name () {
      const user = this.user
      if (user && user.id) {
        const firstName = user.firstName || ''
        const lastName = user.lastName || ''
        return `${firstName} ${lastName}`
      } else {
        return this.email
      }
    },
    locations () {
      const user = this.user
      if (user) { return user.location }
      return ''
    },
    role () {
      const user = this.user
      if (user) { return user.role }
      return ''
    },
    company () {
      const user = this.user
      return (user) ? user.companyName : ''
    }
  },
  methods: {
    click (e) {
      this.$store.dispatch('jobReferral/deleterefferal', { itemindex: this.itemindex, userid: this.item.id, confirmation: true })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/referrals/referral-card.vue